/**
 * Spans are specific (pre-defined) periods of times from a single date (or date-time)
 * e.g last fifteen minutes from now, last month from now
 * @deprecated use TimeSteps instead
 */
var SpanIds;
(function (SpanIds) {
    /** Maximum span */
    SpanIds["maximum"] = "MAX";
    /** 15 minutes span */
    SpanIds["fifteenMinutes"] = "15T";
    /** 15 minutes span */
    SpanIds["thirtyMinutes"] = "30T";
    /** 1 hour span */
    SpanIds["oneHour"] = "1H";
    /** 6 hours span */
    SpanIds["sixHours"] = "6H";
    /** 1 day span */
    SpanIds["oneDay"] = "1D";
    /** 1 week span */
    SpanIds["oneWeek"] = "7D";
    /** 1 month span */
    SpanIds["oneMonth"] = "1M";
    /** 1 trimester span */
    SpanIds["oneTrimester"] = "3M";
    /** 1 year span */
    SpanIds["oneYear"] = "1Y";
    /** custom span */
    SpanIds["custom"] = "C";
})(SpanIds || (SpanIds = {}));
export default SpanIds;
